import {McbGridOrder} from "./mcb-grid-order-dto";
import {McbGridSearch} from "./mcb-grid-search-dto";

export class McbGrid {
  data: any[] = [];
  filters: McbGridSearch[] = [];
  start: number;
  max: number;
  orders: McbGridOrder[] = [];
  count: number;
}
